import ImageHelper, {
  Container as ImageHelperContainer,
} from "@components/ImageHelper"
import colors from "@constants/colors"
import { body14Styles } from "@constants/typography"
import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  cursor: pointer;
`

const GatsbyLink = styled(Link)<any>`
  ${({ to }) => (!to.length ? "pointer-events: none" : "cursor: pointer")};
`

const Content = styled.div`
  display: flex;
  padding-top: 18px;
  align-items: center;
  justify-content: center;
`

const IconWrapper = styled.div`
  width: 16px;
  height: 16px;
`

const Spacer = styled.div`
  width: 12px;
`

const Name = styled.div<{ color?: string }>`
  ${body14Styles}
  max-width: 140px;
  color: ${({ color }) => (color ? `#${color}` : colors.mediumDarkGray)};
  text-align: center;
`

interface ProductSeriesBlockProps {
  color?: string
  icon?: string
  image: string
  link: string
  name: string
  onClick?: () => void
}

const ProductSeriesBlock: React.FC<ProductSeriesBlockProps> = ({
  color,
  icon,
  image,
  link,
  name,
  onClick,
}) =>
  image ? (
    <GatsbyLink to={link}>
      <Container onClick={onClick}>
        <ImageHelper src={image} />
        <Content>
          {icon && (
            <>
              <IconWrapper>
                <ImageHelper src={icon} />
              </IconWrapper>
              <Spacer />
            </>
          )}
          <Name color={color}>{name}</Name>
        </Content>
      </Container>
    </GatsbyLink>
  ) : null

export default ProductSeriesBlock
